export default {"src":"/uk/_next/static/media/spot-money-balancing.2c4ea9e1.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};